import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/_components/card";
import { UI_MESSAGES } from "@/constants/ui-constants";
import { cn } from "@/lib/utils";
import { buttonStyles } from "theme/components/button";
import { ContactFormProps } from "./types";
import { SessionInfo } from "./SessionInfo";
import { ContactSelector } from "./ContactSelector";

export const ContactForm: React.FC<ContactFormProps> = ({
  contactInfo,
  setContactInfo,
  recipients,
  transMasterData,
  isLoadingRecipients,
  isLoadingTransMaster,
  transId,
  agentType,
  onStartChat,
  onKeyDown,
  setSelectedCandidate
}) => {
  const isTpmoAgent = agentType === 'TPMO';
  const isStartDisabled = (() => {
    if (isLoadingRecipients) return true;
    if (!contactInfo.email && !contactInfo.phone) return true;
    
    // For TPMO agent type, subChannel is required when phone is selected
    if (isTpmoAgent && contactInfo.phone && !contactInfo.subChannel) return true;
    
    return false;
  })();
  
  const buttonText = isLoadingRecipients ? "Loading..." : UI_MESSAGES.START_CHAT;
  const headerText = transId ? "Select contact information to start chat" : UI_MESSAGES.ENTER_CONTACT_INFO;

  return (
    <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="max-w-md mx-auto">
        <Card className="shadow-lg border-border">
          <CardHeader className="text-center">
            <CardTitle className="text-xl font-semibold text-foreground">
              Get Started
            </CardTitle>
            <p className="text-sm text-muted-foreground mt-2">
              {headerText}
            </p>
          </CardHeader>
          
          <CardContent className="space-y-6">
            <SessionInfo
              transId={transId}
              agentType={agentType}
              transMasterData={transMasterData}
              isLoadingTransMaster={isLoadingTransMaster}
            />

            <ContactSelector
              contactInfo={contactInfo}
              setContactInfo={setContactInfo}
              recipients={recipients}
              transMasterData={transMasterData}
              isLoadingRecipients={isLoadingRecipients}
              onKeyDown={onKeyDown}
              setSelectedCandidate={setSelectedCandidate}
              agentType={agentType}
            />

            <button
              onClick={onStartChat}
              className={cn(buttonStyles, "w-full bg-blue-600 hover:bg-blue-700")}
              disabled={isStartDisabled}
            >
              {buttonText}
            </button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};